export const ADJECTIVES = [
  'bold',
  'rich',
  'smooth',
  'dark',
  'light',
  'sweet',
  'bitter',
  'creamy',
  'frothy',
  'iced',
  'hot',
  'warm',
  'steamed',
  'whipped',
  'spiced',
  'nutty',
  'mellow',
  'robust',
  'velvet',
  'caramel',
  'vanilla',
  'roasted',
  'brewed',
  'chilled',
  'blonde',
  'decaf',
  'double',
  'single',
  'tall',
  'grande',
  'venti',
  'short',
  'drip',
  'slow',
  'fast',
  'fresh',
  'pure',
  'strong',
  'mild',
  'extra',
  'half',
  'whole',
  'skim',
  'soy',
  'oat',
  'almond',
  'matcha',
  'chai',
  'dirty',
  'skinny',
  'dry',
  'wet',
  'flat',
  'black',
  'white',
  'cozy',
  'quick',
  'morning',
  'evening',
  'midnight',
  'sunrise',
  'sunset',
  'golden',
  'artisan',
  'craft',
  'premium',
  'local',
  'global',
  'classic',
  'modern',
  'vintage',
  'secret',
  'wild',
  'calm',
  'brisk',
  'crisp',
  'zesty',
  'lush',
  'earthy',
  'floral',
  'fruity',
  'sharp',
  'soft',
  'hard',
  'heavy',
  'fancy',
  'simple',
  'lazy',
  'busy'
]

export const NOUNS = [
  'frappe',
  'espresso',
  'latte',
  'mocha',
  'cappuccino',
  'americano',
  'macchiato',
  'cortado',
  'ristretto',
  'affogato',
  'brew',
  'roast',
  'bean',
  'crema',
  'blend',
  'mug',
  'cup',
  'arabica',
  'robusta',
  'drip',
  'pour',
  'flatwhite',
  'coldbrew',
  'nitro',
  'siphon',
  'filter',
  'press',
  'aeropress',
  'chemex',
  'v60',
  'moka',
  'ibrik',
  'pot',
  'percolator',
  'grounds',
  'leaf',
  'tea',
  'chai',
  'matcha',
  'syrup',
  'sugar',
  'honey',
  'milk',
  'cream',
  'foam',
  'steam',
  'shot',
  'pump',
  'splash',
  'dash',
  'drop',
  'sip',
  'gulp',
  'taste',
  'flavor',
  'aroma',
  'scent',
  'heat',
  'ice',
  'cube',
  'slush',
  'crush',
  'whip',
  'drizzle',
  'swirl',
  'art',
  'heart',
  'rosetta',
  'tulip',
  'swan',
  'barista',
  'cafe',
  'shop',
  'counter',
  'bar',
  'table',
  'chair',
  'berry',
  'cherry',
  'seed',
  'plant',
  'tree',
  'farm',
  'crop',
  'yield',
  'batch',
  'glass',
  'tumbler',
  'flask'
]
